import { render, staticRenderFns } from "./ngo-faq.vue?vue&type=template&id=6322c817&"
import script from "./ngo-faq.vue?vue&type=script&lang=js&"
export * from "./ngo-faq.vue?vue&type=script&lang=js&"
import style0 from "./ngo-faq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports